import { render, staticRenderFns } from "./moreOUF.vue?vue&type=template&id=42454d6f&lang=pug&"
import script from "./moreOUF.vue?vue&type=script&lang=js&"
export * from "./moreOUF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports